import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import BasicText from '../DebtPaymentComponents/basicText';
import {errorEnum, stepEnum, successEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import {isMobile} from 'react-device-detect';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {CSSTransition} from 'react-transition-group';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {Container} from 'reactstrap';
import {dwhBitPaymentNotCompleted, dwhBitPaymentNotPossible} from '../reports/dwhReports';

import '../debtPayment.scss';

const BitResultComponent = (props) => {
  const [mount, setMount] = useState(false);
  const [allowToReport, setAllowToReport] = useState(false);
  const selectedAmount = `סכום לתשלום: ${props.privateAmount}`;
  const debtAmount = `סה"כ יתרה: ${props.savedData?.amount}`;
  const source = props.isJetConnection ? 'JET' : 'WEBSITE';
  const customerName = props.savedCustomerData.name;
  const ban = props.selectedBan;
  const idNumber = props.idNumber;
  const subscriber = props.phoneNumber;
  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (
          props.currentStep == errorEnum.BITGENERALERROR ||
          props.currentStep == errorEnum.BITPAYMENTFAILED ||
          props.currentStep == errorEnum.BITPAYMENTIMPOSSIBLE ||
          props.currentStep == successEnum.BITPENDING ||
          props.currentStep == errorEnum.INCORRECTUSER
        ) {
          setMount(true);
        } else {
          setMount(false);
        }
      }
    },
    [props.currentStep],
  );

  useEffect(() => {
    if (props.bitReturnEvent && mount) {
      makeReport();
    }
  }, [props.bitReturnEvent, mount]);

  useEffect(() => {
    if (allowToReport && mount) {
      switch (props.currentStep) {
        case errorEnum.BITPAYMENTFAILED:
          dwhBitPaymentNotCompleted({debtAmount, selectedAmount, source, subscriber, customerName, ban, idNumber});
          break;
        case errorEnum.BITPAYMENTIMPOSSIBLE:
          dwhBitPaymentNotPossible({debtAmount, selectedAmount, source, subscriber, customerName, ban, idNumber});
          break;
      }
      setAllowToReport(false);
    }
  }, [allowToReport, mount, props.currentStep]);

  const resultTitle = () => {
    switch (props.currentStep) {
      case errorEnum.BITGENERALERROR:
        return `מצטערים, משהו השתבש והתהליך לא הושלם`;
      case errorEnum.BITPAYMENTFAILED:
        return 'מצטערים אבל התשלום <br/> ב- bit לא בוצע';
      case errorEnum.BITPAYMENTIMPOSSIBLE:
        return 'מצטערים אבל לא ניתן לשלם באמצעות bit';
      case successEnum.BITPENDING:
        return 'ראינו ששילמת באמצעות bit בקרוב יתקבל אישור תשלום גם כאן';
      case errorEnum.INCORRECTUSER:
        return 'זיהינו חיבור לדפדפן עם חשבון אחר מזה שביצע את תשלום החוב';
    }
  };

  const resultText = () => {
    switch (props.currentStep) {
      case errorEnum.BITGENERALERROR:
        return 'נציגנו יחזור אליך בהקדם האפשרי<br/> כדי לסיים את התהליך';
      case errorEnum.BITPAYMENTFAILED:
        return 'נסה שנית או החלף אמצעי תשלום';
      case errorEnum.BITPAYMENTIMPOSSIBLE:
        return 'אנא החלף אמצעי תשלום';
      case errorEnum.INCORRECTUSER:
        return 'יש להתנתק ולהתחבר עם החשבון עליו בוצע התשלום';
    }
  };

  const getCallback = () => {
    switch (props.currentStep) {
      case errorEnum.BITGENERALERROR:
        return (
          <div className='callback'>
            <div>מעדיפים להתקשר?</div>
            {isMobile ? (
              <a className='call-btn' href={'tel:*'+ window.Config.technicalSupportPhone}>
                <span>חייגו {window.Config.technicalSupportPhone} לנציג שירות </span>
              </a>
            ) : (
              <div className='call-btn'>חייגו {window.Config.technicalSupportPhone} לנציג שירות </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  const getButtons = () => {
    let nextStep;
    switch (props.currentStep) {
      case errorEnum.BITGENERALERROR:
        return (
          <div className='bit-buttons-wrapper'>
            <BtnSubmit onclick={props.redirectToLobby} text={'חזרה לעמוד הראשי'} />
          </div>
        );
      case errorEnum.BITPAYMENTFAILED:
        nextStep = stepEnum.SELECTPAYMENTTYPE;
        return (
          <div className='bit-buttons-wrapper'>
            <div className='mb-3'>
              <BtnSubmit onclick={() => props.handleCurrentStep(nextStep)} text={'אני רוצה לנסות שוב'} />
            </div>
            <div>
              <BtnWhiteBlackBorderBigSize text={'לא תודה'} onclick={props.redirectToLobby} />
            </div>
          </div>
        );
      case errorEnum.BITPAYMENTIMPOSSIBLE:
        nextStep = stepEnum.CREDITCARD;
        return (
          <div className={`bit-buttons-wrapper ${!isMobile ? 'bit-payment-impossible' : ''}`}>
            <BtnSubmit onclick={() => props.handleCurrentStep(nextStep)} text={'לתשלום בכרטיס האשראי'} />
          </div>
        );
      case successEnum.BITPENDING:
        return (
          <div className='bit-buttons-wrapper'>
            <BtnSubmit onclick={props.redirectToLobby} text={'חזרה לאיזור האישי'} />
          </div>
        );
      case errorEnum.INCORRECTUSER:
        return (
          <div className='bit-buttons-wrapper'>
            <BtnSubmit onclick={props.logout} text={'נתקו אותי מהחשבון'} />
          </div>
        );
    }
  };

  return (
    <CSSTransition key={1} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step '>
        <div className={`bit-result ${isMobile ? 'p-0' : ''}`}>
          <div className='content'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
            <div className='bit-result-content'>
              <div className='image'>
                {props.currentStep == successEnum.BITPENDING ? (
                  <Image src={require('../images/clock.svg')} />
                ) : (
                  <Image src={require('../images/error-icon.svg')} />
                )}
              </div>
              <div className='bit-result-content-title' dangerouslySetInnerHTML={{__html: resultTitle()}} />
              <div className='bit-result-content-text' dangerouslySetInnerHTML={{__html: resultText()}} />
            </div>

            {getCallback()}
          </div>
          {getButtons()}
        </div>
      </Container>
    </CSSTransition>
  );
};

export default BitResultComponent;
